import { ForgotPasword } from './ForgotPasword';

export default ForgotPasword;